import { render } from "@/components/pages/menu/Menu.html?vue&type=template&id=f1c7171a&external"
import script from "@/components/pages/menu/Menu.js?vue&type=script&lang=js&external"
export * from "@/components/pages/menu/Menu.js?vue&type=script&lang=js&external"

import "@/components/pages/menu/Menu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__